import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Data } from '../../comum/data/data';
import { CriterioAvaliacao } from '../../comum/modelos/criterio-avaliacao';
import { FiltroResultadoColeta } from '../../comum/modelos/filtro-resultado-coleta';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { ProcessoSetor } from '../../comum/modelos/processo-setor';
import { RotinaProcesso } from '../../comum/modelos/rotina-processo';
import { SetorPontoFisico } from '../../comum/modelos/setor-ponto-fisico';
import { Usuario } from '../../comum/modelos/usuario';
import { PontoFisicoService } from '../../ponto-fisico/ponto-fisico.service';
import { ProcessoService } from '../../processo/processo.service';
import { RotinaService } from '../../rotina/rotina.service';
import { SetorService } from '../../setor/setor.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { SelectItem } from 'primeng/primeng';
import { Setor } from '../../comum/modelos/setor';
import { Processo } from '../../comum/modelos/processo';
import { RotinaCliente } from '../../comum/modelos/rotina-cliente';
import { CookieService } from 'angular2-cookie/core';
import { PermissoesAcessoService } from '../../permissoes-acesso/permissoes-acesso.service';
import { AuthService } from '../../auth/auth.service';
import { AreaCliente } from '../../comum/modelos/area-cliente';
import { ClienteService } from '../../cliente/cliente.service';

@Component({
    selector: 'app-pesquisa-resultado-coleta',
    templateUrl: './pesquisa-resultado-coleta.component.html',
    styleUrls: ['./pesquisa-resultado-coleta.component.css']
})
export class PesquisaResultadoColetaComponent implements OnInit {

    pontosFisicos: PontoFisico[];
    setoresPontoFisico: SetorPontoFisico[];
    setores: Setor[];
    processosSetor: ProcessoSetor[];
    processos: Processo[];
    rotinasProcesso: RotinaProcesso[];
    rotinasCliente: RotinaCliente[];
    usuarios: Usuario[];
    areasCliente: AreaCliente[];
    criteriosAvaliacao: CriterioAvaliacao[];
    areasSelectItem: SelectItem[] = [];
    pontosFisicosSelectItem: SelectItem[] = [];
    setoresSelectItem: SelectItem[];
    processosSelectItem: SelectItem[];
    rotinasSelectItem: SelectItem[];
    criteriosAvaliacaoSelectItem: SelectItem[];
    usuariosSelectItem: SelectItem[];
    areasSelecionadas: number[] = [];
    pontosFisicosSelecionados: number[] = [];
    setoresSelecionados: number[] = [];
    processosSelecionados: number[] = [];
    rotinasSelecionados: number[] = [];
    setoresPontoFisicoSelecionados: number[] = [];
    processosSetorSelecionados: number[] = [];
    rotinasProcessoSelecionados: number[] = [];
    criteriosSelecionados: number[] = [];
    usuariosSelecionados: number[] = [];
    filtroResultadoColeta: FiltroResultadoColeta;
    dateFormat = 'dd/mm/yy';
    selecione = 'Selecione';
    pt: any;
    statusCode: number;
    public loading = false;

    constructor (
        private _pontoFisicoService: PontoFisicoService,
        private _setorService: SetorService,
        private _processoService: ProcessoService,
        private _rotinaService: RotinaService,
        private _usuarioService: UsuarioService,
        private _permissaoService: PermissoesAcessoService,
        private _clienteService: ClienteService,
        private _cookieService: CookieService,
        private authService: AuthService,
        private router: Router,
        private data: Data) {
        this.areasCliente = new Array<AreaCliente>();
        this.pontosFisicos = new Array<PontoFisico>();
        this.setoresPontoFisico = new Array<SetorPontoFisico>();
        this.setores = new Array<Setor>();
        this.processosSetor = new Array<ProcessoSetor>();
        this.processos = new Array<Processo>();
        this.rotinasProcesso = new Array<RotinaProcesso>();
        this.rotinasCliente = new Array<RotinaCliente>();
        this.criteriosAvaliacao = new Array<CriterioAvaliacao>();
        this.usuarios = new Array<Usuario>();
        this.areasSelectItem = new Array<SelectItem>();
        this.pontosFisicosSelectItem = new Array<SelectItem>();
        this.setoresSelectItem = new Array<SelectItem>();
        this.processosSelectItem = new Array<SelectItem>();
        this.rotinasSelectItem = new Array<SelectItem>();
        this.criteriosAvaliacaoSelectItem = new Array<SelectItem>();
        this.usuariosSelectItem = new Array<SelectItem>();
        this.filtroResultadoColeta = new FiltroResultadoColeta();
    }

    ngOnInit() {
        this.pt = {
            firstDayOfWeek: 1,
            dayNames: ['domingo', 'segunda', 'ter\xE7a', 'quarta', 'quinta', 'sexta', 's\xE1bado'],
            dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 's\xE1b'],
            dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
            monthNames: ['janeiro', 'fevereiro', 'mar\xE7o', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro',
                'outubro', 'novembro', 'dezembro'],
            monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
            today: 'Hoje',
            clear: 'Apagar'
        };
        this.loading = true;
        const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
        const usuario = JSON.parse(this._cookieService.get('usuario'));
        const self = this;
        if (this.authService.isAdmin) {
            forkJoin(
                this._usuarioService.obterUsuariosHttp(idCliente),
                this._rotinaService.obterCriteriosAvaliacaoHttp(),
                this._clienteService.obterAreasUsuarioHttp(usuario.idUsuario))
                .subscribe(([usuarios, criterios, areasCliente]) => {
                    this.areasCliente = areasCliente;
                    this.areasCliente.forEach(areaCliente => {
                        this.areasSelectItem.push({ label: areaCliente.area.nomeArea, value: areaCliente.idAreaCliente });
                    });
                    this.usuarios = usuarios;
                    this.usuarios.forEach(usr => {
                        this.usuariosSelectItem.push({ label: usr.nomeUsuario, value: usr.idUsuario });
                    });
                    this.criteriosAvaliacao = criterios;
                    this.criteriosAvaliacao.forEach(criterio => {
                        this.criteriosAvaliacaoSelectItem.push({
                            label: criterio.nomeCriterioAvaliacao, value: criterio.idCriterioAvaliacao
                        });
                    });
                    self.loading = false;
                });
        } else {
            forkJoin(
                this._usuarioService.buscarUsuariosFuncionalidadeHttp(idCliente,
                    'Resultado de Coletas - Usu\u00e1rios', usuario.idUsuario),
                this._rotinaService.obterCriteriosAvaliacaoHttp(),
                this._clienteService.obterAreasUsuarioHttp(usuario.idUsuario))
                .subscribe(([usuarios, criterios, areasCliente]) => {
                    this.areasCliente = areasCliente;
                    this.areasCliente.forEach(areaCliente => {
                        this.areasSelectItem.push({ label: areaCliente.area.nomeArea, value: areaCliente.idAreaCliente });
                    });
                    this.usuarios = usuarios;
                    this.usuarios.forEach(usr => {
                        this.usuariosSelectItem.push({ label: usr.nomeUsuario, value: usr.idUsuario });
                    });
                    this.criteriosAvaliacao = criterios;
                    this.criteriosAvaliacao.forEach(criterio => {
                        this.criteriosAvaliacaoSelectItem.push({
                            label: criterio.nomeCriterioAvaliacao, value: criterio.idCriterioAvaliacao
                        });
                    });
                    self.loading = false;
                });
        }
    }

    onSubmit(): void {
        this.loading = true;
        if (this.rotinasSelecionados !== null && this.rotinasSelecionados !== undefined
            && this.rotinasSelecionados.length > 0) {
            this._rotinaService.obterRotinasProcessosFromRotinasClienteHttp(this.rotinasSelecionados)
                .subscribe(rotinasProcesso => {
                    this.rotinasProcessoSelecionados = new Array<number>();
                    rotinasProcesso.forEach(rotinaProcesso => {
                        this.rotinasProcessoSelecionados.push(rotinaProcesso.idRotinaProcesso);
                    });
                    this.filtroResultadoColeta.idCliente = parseInt(this._cookieService.get('idCliente'), 10);
                    if (this.usuariosSelecionados.length > 0) {
                        this.filtroResultadoColeta.idUsuario = this.usuariosSelecionados;
                    } else {
                        const ids = new Array<number>();
                        ids.push(JSON.parse(this._cookieService.get('usuario')).idUsuario);
                        this.filtroResultadoColeta.idUsuario = ids;
                    }
                    this.filtroResultadoColeta.idPontoFisico = this.pontosFisicosSelecionados;
                    this.filtroResultadoColeta.idSetorPontoFisico = this.setoresPontoFisicoSelecionados;
                    this.filtroResultadoColeta.idProcessoSetor = this.processosSetorSelecionados;
                    this.filtroResultadoColeta.idRotinaProcesso = this.rotinasProcessoSelecionados;
                    this.filtroResultadoColeta.idCriterioAvaliacao = this.criteriosSelecionados;
                    this.data.storage = {
                        'filtroResultadoColeta': this.filtroResultadoColeta
                    };
                    this.router.navigate(['resultado-coleta']);
                    this.loading = false;
                });
        } else {
            this.rotinasSelecionados = new Array<number>();
            this.filtroResultadoColeta.idCliente = parseInt(this._cookieService.get('idCliente'), 10);
            if (this.usuariosSelecionados.length > 0) {
                this.filtroResultadoColeta.idUsuario = this.usuariosSelecionados;
            } else {
                const ids = new Array<number>();
                ids.push(JSON.parse(this._cookieService.get('usuario')).idUsuario);
                this.filtroResultadoColeta.idUsuario = ids;
            }
            this.filtroResultadoColeta.idPontoFisico = this.pontosFisicosSelecionados;
            this.filtroResultadoColeta.idSetorPontoFisico = this.setoresPontoFisicoSelecionados;
            this.filtroResultadoColeta.idProcessoSetor = this.processosSetorSelecionados;
            this.filtroResultadoColeta.idRotinaProcesso = this.rotinasProcessoSelecionados;
            this.filtroResultadoColeta.idCriterioAvaliacao = this.criteriosSelecionados;
            this.data.storage = {
                'filtroResultadoColeta': this.filtroResultadoColeta
            };
            this.router.navigate(['resultado-coleta']);
            this.loading = false;
        }
    }

    selecionarPontosFisicos(idsArea: number[]): void {
        this.loading = true;
        this.pontosFisicosSelecionados = [];
        this.pontosFisicosSelectItem = [];
        this.setoresSelecionados = [];
        this.setoresSelectItem = [];
        this.processosSelectItem = [];
        this.processosSelecionados = [];
        this.processosSetorSelecionados = [];
        this.rotinasSelecionados = [];
        this.rotinasSelectItem = [];
        this.rotinasProcessoSelecionados = [];
        if (idsArea.length > 0) {
            this._pontoFisicoService.obterPontosFisicosAreaHttp(idsArea)
                .subscribe((pfs) => {
                    this.pontosFisicos = pfs;
                    this.pontosFisicos.forEach(pontoFisico => {
                        this.pontosFisicosSelectItem.push({ label: pontoFisico.nomePontoFisico, value: pontoFisico.idPontoFisico });
                    });
                    this.loading = false;
                });
        } else {
            this.loading = false;
        }
    }

    selecionarSetores(idsPontoFisico: number[]): void {
        this.loading = true;
        this.setoresSelecionados = [];
        this.setoresSelectItem = [];
        this.processosSelectItem = [];
        this.processosSelecionados = [];
        this.processosSetorSelecionados = [];
        this.rotinasSelecionados = [];
        this.rotinasSelectItem = [];
        this.rotinasProcessoSelecionados = [];
        const listaPf = new Array<PontoFisico>();
        idsPontoFisico.forEach(id => {
            const pf = new PontoFisico();
            pf.idPontoFisico = id;
            listaPf.push(pf);
        });
        if (idsPontoFisico.length > 0) {
            this._setorService.obterSetoresFromPontosFisicosHttp(listaPf)
                .subscribe((setores) => {
                    this.setores = setores;
                    this.setores.forEach(setor => {
                        this.setoresSelectItem.push({
                            label: setor.nomeSetor, value: setor.idSetor
                        });
                    });
                    this.loading = false;
                });
        } else {
            this.loading = false;
        }
    }

    selecionarProcessos(idsSetor: number[]): void {
        this.loading = true;
        this.processosSelecionados = [];
        this.processosSelectItem = [];
        this.setoresPontoFisicoSelecionados = [];
        this.rotinasSelecionados = [];
        this.rotinasSelectItem = [];
        this.rotinasProcessoSelecionados = [];
        const listaSetor = new Array<SetorPontoFisico>();
        const listaPf = new Array<PontoFisico>();

        this.pontosFisicosSelecionados.forEach(id => {
            const pf = new PontoFisico();
            pf.idPontoFisico = id;
            listaPf.push(pf);
        });
        if (idsSetor.length > 0) {
            this._setorService.obterSetoresPontosFisicosHttp(listaPf)
                .subscribe(setoresPontoFisico => {
                    idsSetor.forEach(idSetor => {
                        setoresPontoFisico.forEach(setorPontoFisico => {
                            if (setorPontoFisico.setor.idSetor === idSetor) {
                                listaSetor.push(setorPontoFisico);
                                this.setoresPontoFisicoSelecionados.push(setorPontoFisico.idSetorPontoFisico);
                            }
                        });
                    });
                    this._processoService.obterProcessosFromSetoresPontoFisicoHttp(listaSetor)
                        .subscribe((processos) => {
                            this.processos = processos;
                            this.processos.forEach(processo => {
                                this.processosSelectItem.push({
                                    label: processo.nomeProcesso, value: processo.idProcesso
                                });
                            });
                            this.loading = false;
                        });
                });
        } else {
            this.loading = false;
        }
    }

    selecionarRotinas(idsProcesso: number[]): void {
        this.loading = true;
        this.rotinasSelectItem = [];
        this.processosSetorSelecionados = [];
        const listaProcessos = new Array<ProcessoSetor>();
        if (idsProcesso.length > 0) {
            this._processoService.obterProcessosSetorClienteHttp(parseInt(this._cookieService.get('idCliente'), 10))
                .subscribe(processosSetor => {
                    idsProcesso.forEach(idProcesso => {
                        processosSetor.forEach(processoSetor => {
                            if (idProcesso === processoSetor.processo.idProcesso) {
                                listaProcessos.push(processoSetor);
                                this.processosSetorSelecionados.push(processoSetor.idProcessoSetor);
                            }
                        });
                    });

                    this._rotinaService.obterRotinasClienteFromProcessosSetorHttp(listaProcessos)
                        .subscribe((rotinasCliente) => {
                            this.rotinasCliente = rotinasCliente;
                            this.rotinasCliente.forEach(rotina => {
                                this.rotinasSelectItem.push({ label: rotina.descricaoRotina, value: rotina.idRotinaCliente });
                            });
                            this.loading = false;
                        });
                });
        } else {
            this.loading = false;
        }
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/pesquisa-resultado-coleta/pesquisa-resultado-coleta.component.ts